import React, {Fragment, useState} from "react";
import Dictionary from "../../Dictionary";
import InputErrorMessage from "../../InputErrorMessage";
import Validator from "../../../../utils/Validator";
import FormattedDateInput from "../../../../components/FormattedDateInput/FormattedDateInput";
import CurrencyInput from "../../../../components/CurrencyInput/CurrencyInput";

function PersonAdditionalDataForm(props) {

    let {formValidator} = props;

    const [contractLengthType, setContractLengthType] = useState("limited");

    const proposalChangeHandler = (event) => {
        let {name, value} = event.target;
        props.onChange({...props.proposal, [name]: value});
    };

    const employerChangeHandler = (event) => {
        let {name, value} = event.target;
        props.onChange({
            ...props.proposal,
            employer: {...props.proposal.employer, [name]: value}
        });
    };

    const personChangeHandler = (event) => {
        let {name, value} = event.target;
        props.onChange({
            ...props.proposal,
            representatives: [{...props.proposal.representatives[0], [name]: value}]
        });
    };

    const contractDatesChangeHandler = (name, date) =>
        props.onChange({...props.proposal, [name]: date});

    const currencyChangeHandler = (name, value) =>
        props.onChange({...props.proposal, [name]: value});

    let employerTypeLabel = "zakładu pracy";

    const contractFromDateField = (
        <FormattedDateInput
            name="contractFrom"
            showOnlyPast={true}
            inputRef={formValidator.register({required: true})}
            value={props.proposal.contractFrom}
            onChange={date => contractDatesChangeHandler("contractFrom", date)}
        />
    );

    const contractToDateField = (
        <FormattedDateInput
            name="contractTo"
            showOnlyFuture={true}
            inputRef={formValidator.register({required: true})}
            value={props.proposal.contractTo}
            onChange={date => contractDatesChangeHandler("contractTo", date)}
        />
    );

    let contractLengthFields = (
        <Fragment>
            <div className="expert-help-field cr-field-full">
                <label className="expert-help-label">Umowa o pracę</label>
                <div className="gearbox-radio-row" style={{marginTop: 8}}>
                    <label className="gearbox-radio-row" style={{padding: 0}}>
                        <input type="radio" name="contractLengthType" value="limited"
                               checked={contractLengthType === "limited"}
                               onChange={() => setContractLengthType("limited")}/>
                        <span className="gearbox-radio-circle"></span>
                        <span className="gearbox-radio-label">na czas określony</span>
                    </label>
                    <label className="gearbox-radio-row" style={{padding: 0}}>
                        <input type="radio" name="contractLengthType" value="unlimited"
                               checked={contractLengthType === "unlimited"}
                               onChange={() => setContractLengthType("unlimited")}/>
                        <span className="gearbox-radio-circle"></span>
                        <span className="gearbox-radio-label">na czas nieokreślony</span>
                    </label>
                </div>
            </div>

            {contractLengthType === "limited" ? (
                <Fragment>
                    <div className="expert-help-field">
                        <label className="expert-help-label" htmlFor="contractFrom">Data zawarcia umowy</label>
                        {contractFromDateField}
                        <InputErrorMessage error={formValidator.errors["contractFrom"]}/>
                    </div>
                    <div className="expert-help-field">
                        <label className="expert-help-label" htmlFor="contractTo">Data zakończenia umowy</label>
                        {contractToDateField}
                        <InputErrorMessage error={formValidator.errors["contractTo"]}/>
                    </div>
                </Fragment>
            ) : (
                <Fragment>
                    <div className="expert-help-field">
                        <label className="expert-help-label" htmlFor="contractFrom">Data zawarcia umowy</label>
                        {contractFromDateField}
                        <InputErrorMessage error={formValidator.errors["contractFrom"]}/>
                    </div>
                    <div className="expert-help-field"></div>
                </Fragment>
            )}
        </Fragment>
    );

    if (props.proposal.employmentForm === "MANDATORY_CONTRACT") {
        employerTypeLabel = "zleceniodawcy";
        contractLengthFields = (
            <Fragment>
                <div className="expert-help-field">
                    <label className="expert-help-label" htmlFor="contractFrom">Data zawarcia umowy</label>
                    {contractFromDateField}
                    <InputErrorMessage error={formValidator.errors["contractFrom"]}/>
                </div>
                <div className="expert-help-field"></div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <h3 className="cr-section-heading cr-field-full">Dane dotyczące zatrudnienia</h3>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="employmentForm">Forma zatrudnienia</label>
                <select id="employmentForm"
                        ref={formValidator.register({required: true})}
                        name="employmentForm"
                        value={props.proposal.employmentForm}
                        onChange={proposalChangeHandler}>
                    {Dictionary.createDictionaryOptionsValueAsKey(Dictionary.EMPLOYMENT_FORM)}
                </select>
                <InputErrorMessage error={formValidator.errors["employmentForm"]}/>
            </div>

            <div className="expert-help-field"></div>

            {contractLengthFields}

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="averageSalary">Wynagrodzenie netto z 3 miesięcy</label>
                <CurrencyInput
                    value={props.proposal.averageSalary}
                    onChange={currencyChangeHandler}
                    inputRef={formValidator.register({required: true})}
                    name="averageSalary"/>
                <InputErrorMessage error={formValidator.errors["averageSalary"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="creditObligationSum">Miesięczne zobowiązania kredytowe</label>
                <CurrencyInput
                    value={props.proposal.creditObligationSum}
                    onChange={currencyChangeHandler}
                    inputRef={formValidator.register({required: true})}
                    name="creditObligationSum"/>
                <InputErrorMessage error={formValidator.errors["creditObligationSum"]}/>
            </div>

            <h3 className="cr-section-heading cr-field-full">Dane dotyczące {employerTypeLabel}</h3>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="nip">{"NIP " + employerTypeLabel}</label>
                <input type="text"
                       id="nip"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{10}/,
                           maxLength: 10,
                           validate: value => Validator.validateNip(value)
                       })}
                       name="nip"
                       value={props.proposal.employer.nip}
                       onChange={employerChangeHandler}
                       placeholder="Np. 1234567890 (10 cyfr)"/>
                <InputErrorMessage error={formValidator.errors.nip} message="Wprowadź poprawny numer NIP (10 cyfr)"/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="phoneNumber">Telefon kontaktowy</label>
                <input type="text"
                       id="phoneNumber"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{9}/,
                           maxLength: 9
                       })}
                       name="phoneNumber"
                       value={props.proposal.employer.phoneNumber}
                       onChange={employerChangeHandler}
                       placeholder="Np. 753421869 (9 cyfr)"/>
                <InputErrorMessage error={formValidator.errors["phoneNumber"]}
                                   message="Podaj poprawny numer telefonu (9 cyfr)"/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="employeePosition">Stanowisko</label>
                <input type="text"
                       id="employeePosition"
                       ref={formValidator.register({required: true})}
                       name="employeePosition"
                       value={props.proposal.representatives[0].employeePosition}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["employeePosition"]}/>
            </div>
        </Fragment>
    );
}

export default PersonAdditionalDataForm;
